import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const storedLang = localStorage.getItem("i18nextLng");

const resources = {
  en: {
    translation: {
      welcome: "Welcome",
      login: "Login",
      logout: "Logout",
      email: "Email",
      password: "Password",
      free_delivery: "Free Delivery",
      hotline: "Contact Us",
      delivery_to: "Delivery To",
      riyadh: "Riyadh",
      home: 'Home',
      occasions: "Occasions",
      language: "Language",
      shopBy: "Shop By",
      occasionsTitle: "Your Occasions",
      our: "Our",
      topSellerProducts: "Top Seller Products",
      viewAll: "View All",
      newArrival: "New Arrival",
      products: "Products",
      recentProducts: "Products",
      shopNow: "Shop Now",
      all: "All",
      discover: "Discover",
      newIdeas: "New Ideas",
      fastDelivery: "Fast Delivery",
      gifts: "Gifts Now",
      subscription: "Weekly Flowers Subscription",
      subscripeNow: "Subscripe Now",
      events: "Events",
      arrangeNow: "Arrange Now",
      ourPartners: "Our Partners",
      springRose: "Spring Rose",
      bannerText: "Say It With Love , Say It With Spring Rose",
      arrangementBy: "Arrangement By Your",
      request: "Request",
      weGiveOurClient: "We Give Our Client",
      flower: "Flower",
      food: "Food",
      forFree: "For Free",
      contactUs: "Contact Us",
      exploreBeauty: "Explore The Timeless Beauty Of Spring Rose",
      complimentary: "Complimentary Gift Wrapping",
      namedDayDelivery: "Named-Day Delivery",
      directFrom: "From our Grower To Your Door",
      carpon: "100% Carbon Neutral",
      addToCart: "Add To Cart",
      added: "Added",
      uploading: "Uploading",
      productNotFound: "Product Not Found",
      addons: "Add On's",
      addon: "Addons",
      description: "Description",
      careTips: "Care Tips",
      relatedProducts: "Related Products",
      personalizeYourOrder: "Personalize Your Order",
      chooseDesign: "Choose A Design",
      message: "Message",
      addLink: "Paste A Link",
      uploadVideo: "Upload Video",
      continueToCart: "Continue To Cart",
      continueShopping: "Continue Shopping",
      specialMessage: "Add A Special Message",
      loading: "Loading",
      error: "Error",
      currency: "SAR",
      noAddressHassle: "No Address Hassle",
      weWillCollect: "We Will Collect The Address For You",
      freeDeliveryMessage: "Free delivery on all orders.",
      waysToPay: "Ways To Pay",
      emptyCartMessage: "Looks Like You Haven't Added Anything Yet",
      emptyCartLabel: "Your Cart Is Empty",
      browseProducts: "Browse Products",
      product: "Product",
      quantity: "Quantity",
      price: "Price",
      subTotal: "SubTotal",
      subto: "Sub To",
      addedLink: "Custom Link",
      uploadedMedia: "Uploaded Media",
      each: "each",
      applyCoupon: "Apply Coupon",
      couponCode: "Coupon Code",
      clearCart: "Clear Shopping Cart",
      orderSummary: "Order Summary",
      items: "Items",
      couponDiscount: "Coupon Discount",
      total: "Total",
      video: "Video",
      completeYourOrder: "Complete Your Order",
      orderType: "Order Type",
      sendAsAgift: "Send As A Gift",
      deliverToMyAddress: "Deliver To My Address",
      pickupFromStore: "Pick Up From Store",
      selectAddress: "Select Address",
      deliveryDate: "Delivery Data",
      deliveryTime: "Delivery Time",
      completeOrder: "Complete Order",
      recipName: "Recipient Name",
      recipPhone: "Recipient Phone",
      deliveryLocation: "Delivery Location",
      searchLocation: "Search Locaton",
      enterRecipName: "enter recipient name",
      enterRecipPhone: "enter recipient phone",
      unknownAddress: "I Don't Know The Address",
      hideMyInfoLabel: "Show My Info On Gift?",
      hideMyInfo: "Yes , Include My Info",
      selectTimeRange: "Select Time Range",
      selectBranch: "Select Branch",
      requiredRecipName: "Recipient Name is Required",
      requiredRecipPhone: "Recipient Phone Is Required",
      phoneValidation: "Phone number must be 7 to 10 digits long",
      requiredAddress: "Address Is Required",
      requiredDate: "Delivery Date Is Required",
      requiredTime: "Delivery Time Is Required",
      requiredBranch: "Please Select A Branch",
      processing: "Processing",
      selectedLocation: "Selected Location",
      errorLoadingMaps: "Error Loading Maps",
      freeShippingLabel: "Free Shipping",
      freeShippingMessage: "Free Shipping for All Orders",
      flexiblePaymentLabel: "Flexible Payment",
      flexiblePaymentMessage: "Multple Secure Payment Options",
      clientSupportLabel: "24x7 Support",
      clientSupportMessage: "We Support Online All Days",
      trackOrder: "Track Order",
      trackOrderMessage: "To track your order please enter your Order ID in the box below and press the Track Order button. This was given to you on your receipt and in the confirmation email you should have received.",
      enterOrderId: "Enter Your Order ID",
      footerText: "Spring Rose Company was founded in 1992 and is one of the leading flower companies in Saudi Arabia. With branches in Riyadh and Khobar, we specialize in offering distinctive and customized floral arrangements tailored for various occasions, whether for individuals or businesses. For over 30 years, we have been proudly serving our clients.",
      followUs: "Follow Us",
      shop: "Shop",
      topSelling: "Top Selling",
      freshPicks: "Fresh Picks",
      myAccount: "My Account",
      trackYourOrder: "Track Your Order",
      shippingPolicy: "Shipping Policy",
      privacyPolicy: "Privacy Policy",
      termsConditions: "Terms & Conditions",
      aboutUs: "About Us",
      faq: "FAQ",
      downloadOurApp: "Download Our App",
      customerServices: "Customer Services",
      copyRight: "CopyRights",
      allRightsReserved: "Spring Rose.All Rights Reserved",
      catalogs: "Catalogs",
      categories: "Categories",
      filterOptions: "Filter Options",
      byCategories: "By Categories",
      byCatalogs: "By Catalogs",
      clearFilters: "Clear Filters",
      activeFilters: "Active Filters",
      sortBy: "Sort By",
      newestFirst: "Newest First",
      oldestFirst: "Oldest First",
      highToLow: "Price:High To Low",
      lowToHigh: "Price:Low To High",
      category: "Category",
      catalog: "Catalog",
      productsNumber: "Products",
      filter: "Filter",
      orderStatus: "Order Status",
      orderId: "Order ID",
      orderDetails: "Order Details",
      productsNoun: "Products",
      pending: "Pending",
      accepted: "Accepted",
      delivered: "Delivered",
      rejected: "Rejected",
      refunded: "Refunded",
      cancelled: "Cancelled",
      outForDelivery: "Out For Delivery",
      order: "Order",
      doYouHaveQuestions: "You Have Different Questions?",
      ourTeamWillAnswer: "Out Team Will Answer All Your Questions.",
      weEnsureQuickResponse: "We Ensure A Quick Response",
      name: "Name",
      phone: "Phone Number",
      sendMessage: "Send Message",
      addresses: "Addresses",
      requiredName: "Name is required",
      requiredPhone: "Phone is required",
      requiredEmail: "Email is required",
      requiredMessage: "Message is required",
      yourName: "Your Name",
      yourPhone: "Your phone number",
      yourMessage: "Your message",
      yourEmail: "Your Email",
      messageSubmitted: "Message Submitted Successfully",
      failedToLoadBanners: "Failed To Load Banners",
      uploadComplete: "Upload Complete",
      yourOrderIsCompleted: "Your Order Is Completed!",
      orderRecieved: "Thank you, Your Order has been recieved.",
      totalPayment: "Total Payment",
      paymentMethod: "Payment Method",
      orderTime: "Order Time",
      downloadInvoice: "Download Invoice",
      invoice: "Invoice",
      shipping: "Shipping",
      taxes: "Taxes",
      generalInfo: "General Info",
      myOrders: "My Orders",
      passwordManager: "Password Manager",
      favorites: "Wishlist",
      noImage: "No image",
      dateOfBirth: "Date Of Birth",
      gender: "Gender",
      bio: "Bio",
      newPassword: "New Password",
      tellUsAboutYourself: "Tell us about yourself",
      male: "Male",
      female: "Female",
      optional: "Optional",
      updateProfile: "Update Profile",
      emptyFavoritesLabel: "Your favorites is Empty",
      emptyFavoritesText: "Looks like you haven't added any items to your favorites yet.",
      clearFavorites: "Clear Favorites",
      showing: "Showing",
      emptyOrdersLabel: "Looks Like You Didn't Order Anything Yet",
      emptyOrdersText: "you can start looking here",
      yourOrderHasBeen: "Your Order Has Been",
      cancelledVerb: "Cancelled",
      cancelOrder: "Cancel Order",
      allOrders: "All Orders",
      noOrderByThatStatus: "No Orders By That Status",
      deleteAddressLabel: "Are you sure you want to delete the address?",
      delete: "Delete",
      edit: "Edit",
      addressDesc: "Detailed Address Description",
      addressDescPlaceholder: "Apartment name , nearby landmark, etc..",
      requiredAddressDesc: "address description is required",
      addressType: "Address Type",
      homeAddress: "Home Address",
      officeAddress: "Office Address",
      city: "City",
      selectCity: "Select City",
      buildingNumber: "Building Number",
      aptNumber: "Apartment Number",
      makeDefaultAddress: "Make default Address",
      saveAddress: "Save Address",
      requiredCity: "City is Required",
      cancel: "Cancel",
      addNewAddress: "Add New Address",
      editAddress: "Edit Address",
      updateAddress: "Update Address",
      noRelatedProducts: "No Related Products For This Product",
      pleaseFillLoginData: "please fill your details to access your account",
      forgotPassword: "Forgot Password?",
      signInWithGoogle: "Sign in with google",
      orSignInWithGoogle: "Or sign in with google",
      dontHaveAccount: "Don't have an account?",
      pleaseFillRegisterData: "please fill your information below or register with your google account",
      requiredPassword: "password is required",
      unmatchedPassword: "passwords must match",
      alreadyHaveAccount: "already have an account?",
      wrongLoginData: "invalid phone or password",
      emailAlreadyUsed: "email already registered",
      invalidSaudiNumber: "invalid saudi number",
      alreadyUsedPhone: "phone already registered",
      enterPassword: "Enter Password",
      signUp: "Sign Up",
      loginFailed: "Login Failed , please try again",
      dublicateEntry: "Dublicate Entry Found , please use different credentials",
      registrationFailed: "Registeration failed , please try again",
      requiredBirthDate: "Birth Date is required",
      requiredGender: "Gender is required",
      confirmPassword: "Confirm Password",
      requiredConfirmPassword: "please Confirm your password",
      orSignUpWithGoogle: "Or sign up with google",
      signUpWithGoogle: "Sign up with google",
      oops: "Oops!",
      pageNotFoundLabel: "Page Not Found",
      pageNotFoundText: "The page you are looking for cannot be found. take a break before trying again",
      goToHomePage: "Go To Home Page",
      enterPhone: "Enter your phone number",
      sendOtp: "Send OTP",
      otpSentSuccess: "OTP sent successfully. It is valid for 10 minutes.",
      failedToSendOtp: "Failed to send OTP, please try again.",
      enterOtp: "Enter the OTP code sent to your phone",
      otpPlaceholder: "Enter OTP here",
      verifyOtp: "Verify OTP",
      invalidOtp: "Invalid OTP, please check and try again.",
      resendOtp: "Resend OTP",
      otpValidityMessage: "OTP is valid for only 10 minutes.",
      didntRecieve: "Didn't receive?",
      otpExpiresIn: "OTP Expires in",
      otpExpired: "OTP Expired please try again",
      passwordMinLength: "password must be at least 6 characters",
      signInWithPassword: "Sign In With Password",
      signInWithOtp: "Sign In With OTP",
      invalidLoginData: "phone or password is incorrect",
      resetPasswordTitle: "Reset Password",
      userNotFound: "Phone Not Found",
      orderFailure: "Your order failed on payment",
      failedOrderRecieved: "Sorry , it seems that you failed to pay for the order",
      retryPayment: "Try paying again",
      noAddons: "Sorry no addons by that type in this location",
      show: "Show",
      openApp: "Open App",
      appBannerLabel: "Have you tried our app?",
      appBannerText: "its faster, easier to browse and have many exclusive features",
      flowers: "Flowers",
      balloons: "Balloons",
      giftsSection: "Flowers with Gifts",
      perfume: "Perfumes",
      emptyCategoryProducts: "oops, no products for this category yet.",
      weDeliverHappiness: "We Deliver Happiness",
    },
  },
  ar: {
    translation: {
      welcome: "مرحبا",
      login: "تسجيل الدخول",
      logout: "تسجيل الخروج",
      email: "البريد الإلكتروني",
      password: "كلمة المرور",
      free_delivery: "شحن مجاني",
      hotline: "تواصل معنا",
      delivery_to: "التوصيل الى",
      riyadh: "الرياض",
      home: 'الرئيسيه',
      occasions: "المناسبات",
      language: "اللغه",
      shopBy: "تسوق ",
      occasionsTitle: "حسب مناسباتك المختلفه",
      our: "",
      topSellerProducts: "الاكثر مبيعا",
      viewAll: "عرض الكل",
      newArrival: "احدث",
      products: "باقاتنا",
      recentProducts: "الباقات",
      shopNow: "تسوق الان",
      all: "جميع",
      discover: "تعرف علي",
      newIdeas: " خدماتنا الجديده",
      fastDelivery: "توصيل سريع",
      gifts: "الهدايا الان",
      subscription: " باقات اسبوعيه",
      subscripeNow: "تابع الان",
      events: "المناسبات والفعاليات",
      arrangeNow: "نظم الان",
      ourPartners: "شركاؤنا",
      springRose: "زهرة الربيع",
      bannerText: "قلها بحب , قلها مع زهرة الربيع",
      arrangementBy: "التحضيرات بناء علي",
      request: "طلبك",
      weGiveOurClient: "نعطي عملاؤنا",
      flower: "زهور",
      food: "طعام",
      forFree: "مجانا",
      contactUs: "تواصل معنا",
      exploreBeauty: " جمالية المكان تكتشفها مع زهرة الربيع",
      complimentary: "تغليف هدايا مجانا",
      namedDayDelivery: "توصيل في اليوم المحدد",
      directFrom: "من مزارعنا لبابك",
      carpon: "100% محايد للكربون",
      addToCart: "اضف للعربه",
      added: "تمت الاضافه",
      uploading: "جاري الرفع",
      productNotFound: "لم يتم ايجاد المنتج",
      addons: "الاضافات",
      addon: "الاضافات",
      description: "الوصف",
      careTips: "توصيات العنايه بالمنتج",
      relatedProducts: "المنتجات المتعلقه",
      personalizeYourOrder: "خصص طلبك",
      chooseDesign: "اختر تصميما",
      message: "الرساله",
      addLink: "اضف رابطا",
      uploadVideo: "ارفع فيديو",
      continueToCart: "الاستمرار الي العربه",
      continueShopping: "الاستمرار في التسوق",
      specialMessage: "اضف رساله مميزه",
      loading: "جاري التحميل",
      error: "خطا",
      currency: "ر.س",
      noAddressHassle: "لا متاعب في تحديد العنوان",
      weWillCollect: "سوف نجد ذلك من اجلك",
      freeDeliveryMessage: "شحن مجاني علي جميع الطلبات.",
      waysToPay: "طرق الدفع",
      emptyCartMessage: "يبدو انك لم تقم باضافة اي منتج بعد",
      emptyCartLabel: "العربه فارغه",
      browseProducts: "تصفخ منتجاتنا",
      product: "المنتج",
      quantity: "الكميه",
      price: "السعر",
      subTotal: "المجموع",
      subto: "المجموع",
      addedLink: "الرابط المضاف",
      uploadedMedia: "الميديا المضافه",
      each: "لكل واحده",
      applyCoupon: "اضف الكوبون",
      couponCode: "كود الكوبون",
      clearCart: "افراغ عربة التسوق",
      orderSummary: "ملخص الطلب",
      items: "عدد الاغراض",
      couponDiscount: "خصم الكوبون",
      total: "المجموع الكلي",
      video: "الفيديو",
      completeYourOrder: "اكمل طلبك",
      orderType: "نوع الطلب",
      sendAsAgift: "ارسل كهديه",
      deliverToMyAddress: "وصل لعنواني",
      pickupFromStore: "استلام من المتجر",
      selectAddress: "اختر العنوان",
      deliveryDate: "تاريخ التوصيل",
      deliveryTime: "وقت التوصيل",
      completeOrder: "اكمل الطلب",
      recipName: "اسم المستلم",
      recipPhone: "هاتف المستلم",
      deliveryLocation: "عنوان التوصيل",
      searchLocation: "ابحث عن العنوان",
      enterRecipName: "ادخل اسم المستلم",
      enterRecipPhone: "ادخل هاتف  المستلم",
      unknownAddress: "لا اعرف العنوان",
      hideMyInfoLabel: "!!عرض معلوماتي",
      hideMyInfo: "نعم , اعرض معلوماتي مع الطلب",
      selectTimeRange: "حدد وقت التوصيل",
      selectBranch: "حدد الفرع",
      requiredRecipName: "اسم المستلم مطلوب",
      requiredRecipPhone: "هاتف المستلم مطلوب",
      phoneValidation: "الهاتف يجب ان يكون مكون من 7-10 ارقام",
      requiredAddress: "من فضلك اختر العنوان",
      requiredDate: "تاريخ التوصيل مطلوب",
      requiredTime: "وقت التوصيل مطلوب",
      requiredBranch: "من فضلك اختر الفرع",
      processing: "جاري التحميل",
      selectedLocation: "الموقع المحدد",
      errorLoadingMaps: "خطا في تحميل الخرائط",
      freeShippingLabel: "توصيل مجاني",
      freeShippingMessage: "توصيل مجاني لجميع الطلبات",
      flexiblePaymentLabel: "وسائل دفع مرنه",
      flexiblePaymentMessage: "الكثير من وسائل الدفع الآمنه",
      clientSupportLabel: "خدمة عملاء دائمه",
      clientSupportMessage: "في خدمتك طول الوقت",
      trackOrder: "تتبع الطلب",
      trackOrderMessage: "لمتابعة طلبك، يرجى إدخال رقم الطلب في الخانة أدناه ثم الضغط على زر تتبع الطلب تم تزويدك بهذا الرقم في إيصال الشراء وفي رسالة التأكيد التي تم إرسالها إلى بريدك الإلكتروني.      .      ",
      enterOrderId: "ادخل رقم الطلب الخاص بك",
      footerText: "تأسست شركة زهرة الربيع في عام 1992، وهي واحدة من الشركات الرائدة في مجال الزهور في المملكة العربية السعودية. مع فروعنا في الرياض والخبر، نختص في تقديم تنسيقات زهور مميزة ومخصصة تلائم مختلف المناسبات، سواء للأفراد أو الشركات. على مدار أكثر من 30 عامًا",
      followUs: "تابعنا",
      shop: "المتجر",
      topSelling: "الاعلي مبيعا",
      freshPicks: "المقطوف حديثا",
      myAccount: "حسابي",
      trackYourOrder: "تتبع طلبك",
      shippingPolicy: "سياسة الشحن",
      privacyPolicy: "سياسة الخصوصية",
      termsConditions: "الشروط و الاحكام",
      aboutUs: "من نحن",
      faq: "الاسئله الشائعه",
      downloadOurApp: "حمل تطبيقنا",
      customerServices: "خدمة العملاء",
      copyRight: " ",
      allRightsReserved: "زهرة الربيع .جميع الحقوق محفوظه",
      catalogs: "المناسبات",
      categories: "التصنيفات",
      filterOptions: "خيارات التصفيه",
      byCategories: "حسب التصنيف",
      byCatalogs: "حسب المناسبه",
      clearFilters: "مسح التصفيات",
      activeFilters: "التصفيات النشطه",
      sortBy: "تصنيف حسب",
      newestFirst: "الاحدث",
      oldestFirst: "الاقدم",
      highToLow: "الاغلي ثمنا",
      lowToHigh: "الارخص ثمنا",
      category: "تصنيف",
      catalog: "مناسبه",
      productsNumber: "منتج",
      filter: "التصفيه",
      orderStatus: "حالة الطلب",
      orderId: "رقم الطلب",
      orderDetails: "تفاصيل الطلب",
      productsNoun: "المنتجات",
      pending: "قيد الانتظار",
      accepted: "تم القبول",
      delivered: "تم التوصيل",
      rejected: "مرفوض",
      refunded: "تم الاسترداد",
      cancelled: "تم الالغاء",
      outForDelivery: "خارج للتوصيل",
      order: "الطلب",
      doYouHaveQuestions: "لديك اسئله اخري؟",
      ourTeamWillAnswer: "فريقنا سوف يقوم باجابة جميع اسئلتك.",
      weEnsureQuickResponse: "نؤكد لك الرد السريع.",
      name: "الاسم",
      phone: "رقم الهاتف",
      sendMessage: "ارسل الرساله",
      addresses: "العناوين",
      requiredName: "الاسم مطلوب",
      requiredPhone: "الهاتف مطلوب",
      requiredEmail: "الايميل مطلوب",
      requiredMessage: "الرساله مطلوبه",
      yourName: "الاسم",
      yourPhone: "رقم الهاتف",
      yourMessage: "الرساله",
      yourEmail: "البريد الالكتروني",
      messageSubmitted: "تم ارسال الرساله بنجاح",
      failedToLoadBanners: "فشل في تحميل اللوحه",
      uploadComplete: "تم الرفع",
      yourOrderIsCompleted: "تم اكمال الطلب بنجاح!",
      orderRecieved: "شكرا لك, تم استلام طلبك.",
      totalPayment: "المدفوع كليا",
      paymentMethod: "طريقة الدفع",
      orderTime: "وقت الطلب",
      downloadInvoice: "تحميل الفاتوره",
      invoice: "الفاتوره",
      shipping: "الشحن",
      taxes: "الضريبه",
      generalInfo: "معلومات عامه",
      myOrders: "الطلبات",
      passwordManager: "ادارة كلمة السر",
      favorites: "المفضله",
      noImage: "لا توجد صوره",
      dateOfBirth: "تاريخ الميلاد",
      gender: "الجنس",
      bio: "نبذه",
      newPassword: "رقم سري جديد",
      tellUsAboutYourself: "اخبرنا عنك",
      male: "ذكر",
      female: "انثي",
      optional: "اختياري",
      updateProfile: "تحديث البيانات",
      emptyFavoritesLabel: "المفضله فارغه",
      emptyFavoritesText: "يبدو انك لم تقم باضافه اي منتج للمفضله بعد",
      clearFavorites: "تفريغ المفضله",
      showing: "اظهار",
      emptyOrdersLabel: "يبدو انك لم تقم بطلب اي شىئ بعد",
      emptyOrdersText: "يمكنك البدء بالطلب هنا",
      yourOrderHasBeen: "طلبك ",
      cancelledVerb: "الغاؤه",
      cancelOrder: "الغاء الطلب",
      allOrders: "جميع الطلبات",
      noOrderByThatStatus: "لا توجد طلبات بهذه الحاله",
      deleteAddressLabel: "هل انت متاكد من حذف هذا العنوان؟",
      delete: "حذف",
      edit: "تعديل",
      addressDesc: "وصف العنوان بالتفصيل",
      addressDescPlaceholder: "اسم الشقه او علامه مميزه قريبه منك او اخري..",
      requiredAddressDesc: "وصف العنوان مطلوب",
      addressType: "نوع العنوان",
      homeAddress: "عنوان منزل",
      officeAddress: "عنوان مكتب",
      city: "المدينه",
      selectCity: "حدد المدينه",
      buildingNumber: "رقم المبني",
      aptNumber: "رقم الشقه",
      makeDefaultAddress: "اجعله عنواني الافتراضي",
      saveAddress: "حفظ العنوان",
      requiredCity: "تحديد المدينه مطلوب",
      cancel: "الغاء",
      addNewAddress: "اضافة عنوان حديد",
      editAddress: "تعديل العنوان",
      updateAddress: "تحديث العنوان",
      noRelatedProducts: "لا يوجد منتجات ذات صله بهذا المنتج",
      pleaseFillLoginData: "من فضلك ادخل بيانات تسجيل الدخول",
      forgotPassword: "نسيت الرقم السري؟",
      signInWithGoogle: "تسجيل الدخول عن طريق جوجل",
      orSignInWithGoogle: "او سجل الدخول عن طريق جوجل",
      dontHaveAccount: "ليس لديك حساب؟",
      pleaseFillRegisterData: "من فضلك املأ البيانات بالاسفل او سجل عن طريق جوجل",
      requiredPassword: "الرقم الرس مطلوب",
      unmatchedPassword: "كلمة السر يجب ان تطابق",
      alreadyHaveAccount: "لديك حساب بالفعل؟",
      wrongLoginData: "خطا في الهاتف او الرقم السري",
      emailAlreadyUsed: "البريد الالكتروني مسجل بالفعل",
      invalidSaudiNumber: "يجب ان يكون رقم الهاتف سعوديا",
      alreadyUsedPhone: "رقم الهاتف مسجل بالفعل",
      enterPassword: "ادخل كلمة المرور",
      signUp: "انشاء حساب",
      loginFailed: "فشل تسجيل الدخول , من فضلك حاول مره اخري",
      dublicateEntry: "البيانات مسجله مسبقا ,من فضلك استخدم بيانات اخرى",
      registrationFailed: "فشل في انشاء الحساب, من فضلك حاول مره اخرى",
      requiredBirthDate: "تاريخ الميلاد مطلوب",
      requiredGender: "الجنس مطلوب",
      confirmPassword: "تاكيد كلمة المرور",
      requiredConfirmPassword: "اكد رقم المرور",
      orSignUpWithGoogle: "او انشئ حسابا عن طريق جوجل",
      signUpWithGoogle: "انشئ حسابا عن طريق جوجل",
      oops: "اوبس!",
      pageNotFoundLabel: "هذه الصفحه غير موجوده",
      pageNotFoundText: "هذه الصفحه غير موجوده من فضلك حاول مره اخرى",
      goToHomePage: "اذهب الي الرئيسه",
      enterPhone: "ادخل رقم هاتفك",
      sendOtp: "ارسل الرمز",
      otpSentSuccess: "تم ارسال الرمز بنجاح",
      failedToSendOtp: "خطا في ارسال الرمز من فضلك حاول مره اخرى",
      enterOtp: "ادخل الرمز المرسل الي هاتفك هنا",
      otpPlaceholder: "ادخل الرمز هنا",
      verifyOtp: "تحقق من الرمز",
      invalidOtp: "رمز خاطئ من فضلك حاول مره اخرى",
      resendOtp: "ارسل مجددا",
      otpValidityMessage: "الرمز صالح لمدة عشر دقائق فقط",
      didntRecieve: "لم تستلم رمزا؟",
      otpExpiresIn: "الرمز صالح لمدة",
      otpExpired: "انتهت صلاحية الرمز من فضلك حاول مرة اخري",
      passwordMinLength: "كلمة المرور يجب الا تقل عن 6 حروف",
      signInWithPassword: "تسجيل الدخول بكلمة المرور",
      signInWithOtp: "تسجيل الدخول برمز OTP",
      invalidLoginData: "كلمة مرور او رقم هاتف غير صحيح",
      resetPasswordTitle: "استعادة كلمة المرور",
      userNotFound: "الهاتف غير موجود",
      orderFailure: "طلبك فشل في عملية الدفع",
      failedOrderRecieved: "ناسف لذلك و لكن يبدو ان هناك مشكله في عمليه الدفع",
      retryPayment: "حاول الدفع مرة اخرى",
      noAddons: "ناسف لذلك , لا توجد اضافات من هذا النوع في منطقة التوصيل المختاره",
      show: "عرض",
      openApp: "افتح التطبيق",
      appBannerLabel: "هل جربت تطبيقنا؟",
      appBannerText: "اسرع واسهل في التصفح ويحتوي علي الكثير من المزايا الحصريه",
      flowers: "زهرة",
      balloons: "بالون",
      giftsSection: "ورد مع هدايا",
      perfume: "عطورات",
      emptyCategoryProducts: "اوبس, لا توجد منتجات في هذا التصنيف بعد.",
      weDeliverHappiness: "نحن نوصل السعادة",
    },
  },
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: storedLang || "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
